export { ScrollspyNav } from './src/ScrollspyNav';
export type { ScrollspyNavItem, ScrollspyNavProps } from './src/ScrollspyNav.types';
